'use client';

import Flex from '@/components/Flex';
import cx from 'classnames';

import styles from './Spinner.module.scss';

export type SpinnerVariant = 'large' | 'small';

interface SpinnerProps {
  className?: string;
  variant?: SpinnerVariant;
  message?: string;
}

/**
 * Spinner component that supports two size variants and an optional message.
 *
 * @param {SpinnerProps} props - Component props.
 * @param {SpinnerVariant} [props.variant='large'] - Determines the spinner size and style.
 * @param {string} [props.message] - Optional message displayed near the spinner.
 * @returns {JSX.Element} The spinner element.
 */
export const Spinner = ({
  className,
  variant = 'large',
  message,
}: SpinnerProps) => (
  <Flex
    alignItemsCenter
    justifyCenter
    style={variant === 'large' ? { height: '100%' } : {}}
    className={cx(styles.container, className)}
  >
    <div className={styles.spinnerWrapper}>
      <span
        className={
          variant === 'large'
            ? styles.spinnerLargeIcon
            : styles.spinnerSmallIcon
        }
      />
      {message && <h3 className={styles.message}>{message}</h3>}
    </div>
  </Flex>
);
